import { render } from "./CustomerCard.vue?vue&type=template&id=641a9e39&scoped=true"
import script from "./CustomerCard.vue?vue&type=script&lang=js"
export * from "./CustomerCard.vue?vue&type=script&lang=js"

import "./CustomerCard.vue?vue&type=style&index=0&id=641a9e39&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641a9e39"]])

export default __exports__